import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-add input-form flex-center" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
      placeholder: 'Name',
      class: "border-2 border-gray-300 p-1 flex-grow text-black rounded-l",
      onKeypress: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)), ["enter"]))
    }, null, 544), [
      [_vModelText, _ctx.name]
    ]),
    _createElementVNode("button", {
      class: "bg-gray-300 p-1 text-black border-2 border-gray-300 rounded-r",
      disabled: !_ctx.name,
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
    }, "Add", 8, _hoisted_2)
  ]))
}